// export const ORIGIN = 'http://3.6.156.104:8000';
export const PORT=9200
// export const ORIGIN = 'http://localhost:8000';
export const ORIGIN = 'https://api.buildpan.com';


